import { create } from '@/store'
import { devtools } from 'zustand/middleware'

const notificationStore = create(
  devtools(
    (set) => ({
      isNotificationSocketConnected: false,
      isNotificationListLoading: true,
      isNewNotification: new Date(),
      unreadCount: 0,
      notifications: [],
      unreadNotifications: [],
      skipFromId: '',
      setIsSocketConnected: (isConnected) =>
        set({ isNotificationSocketConnected: isConnected }),
      setIsNotificationListLoading: (isLoading) =>
        set({ isNotificationListLoading: isLoading }),
      setUnreadCount: (count) => set({ unreadCount: count }),
      addUnreadCount: (count) => {
        set((state) => ({
          unreadCount: state.unreadCount + count,
        }))
      },
      setNotification: (data) => set({ notifications: data }),
      setUnreadNotifications: (data) => set({ unreadNotifications: data }),
      addNotification: (data) => {
        set((state) => ({
          notifications: [{ ...data }, ...state.notifications],
          isNewNotification: new Date(),
        }))
      },
      addUnreadNotifications: (data) => {
        set((state) => ({
          unreadNotifications: [...state.unreadNotifications, { ...data }],
        }))
      },
      removeNotification: (index) => {
        set((state) => ({
          notifications: state.notifications.filter((_, i) => i !== index),
        }))
      },
    }),
    {
      name: 'notification-store',
    },
  ),
)
export default notificationStore
